import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { AdminLayout } from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Star, Plus, Pencil } from "lucide-react";

export default function AdminLocations() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [open, setOpen] = useState(false);

  const load = () => api.get("/locations", { params: { active_only: false } }).then(r => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      const payload = { name: editing.name, organization_id: editing.organization_id || null,
        location_type: editing.featured ? "featured" : "standard", featured: !!editing.featured, active: editing.active !== false };
      if (editing.id) await api.patch(`/admin/locations/${editing.id}`, payload);
      else await api.post("/admin/locations", payload);
      toast.success("Sparat"); setOpen(false); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Fel"); }
  };

  return (
    <AdminLayout title="Platser" actions={
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild><Button data-testid="loc-new" onClick={() => setEditing({ name: "", featured: false, active: true })} className="bg-[#E1251B] hover:bg-[#C81D14] rounded-full"><Plus size={16} className="mr-1"/>Ny plats</Button></DialogTrigger>
        <DialogContent>
          <DialogHeader><DialogTitle>{editing?.id ? "Redigera" : "Ny"} plats</DialogTitle></DialogHeader>
          {editing && (<div className="space-y-3">
            <div><Label>Namn</Label><Input data-testid="loc-name" value={editing.name} onChange={e => setEditing({ ...editing, name: e.target.value })}/></div>
            <div className="flex items-center justify-between"><Label>Nyckelplats</Label><Switch checked={!!editing.featured} onCheckedChange={v => setEditing({ ...editing, featured: v })}/></div>
            <div className="flex items-center justify-between"><Label>Aktiv</Label><Switch checked={editing.active !== false} onCheckedChange={v => setEditing({ ...editing, active: v })}/></div>
          </div>)}
          <DialogFooter><Button data-testid="loc-save" onClick={save} className="bg-[#E1251B] hover:bg-[#C81D14]">Spara</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    }>
      <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden">
        <Table>
          <TableHeader><TableRow><TableHead>Namn</TableHead><TableHead>Typ</TableHead><TableHead>Status</TableHead><TableHead></TableHead></TableRow></TableHeader>
          <TableBody>
            {items.map(o => (
              <TableRow key={o.id} data-testid={`loc-item-${o.name}`}>
                <TableCell className="font-medium flex items-center gap-2">{o.featured && <Star size={14} className="text-[#E1251B] fill-[#E1251B]"/>}{o.name}</TableCell>
                <TableCell className="capitalize">{o.location_type}</TableCell>
                <TableCell><span className={`text-xs px-2 py-0.5 rounded-full ${o.active ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-500"}`}>{o.active ? "Aktiv" : "Inaktiv"}</span></TableCell>
                <TableCell className="text-right"><Button size="sm" variant="ghost" onClick={() => { setEditing(o); setOpen(true); }}><Pencil size={14}/></Button></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </AdminLayout>
  );
}
